<template>
  <div class='EnbPreference'>
    <pref-nave/>
    <div class="cont-view">
      <router-view/>
    </div>
    <div class="cont-btn">
      <button :disabled="updating" @click="update" >
        <span v-if="!updating">Atualizar</span>
        <vue-spinner size="30" v-if="updating"/>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PrefNave from './PrefNave'
export default {
  name: 'EnbPreference',
  components: { PrefNave },
  data () {
    return {
      updating: false
    }
  },
  computed: {
    ...mapGetters(['Themes', 'Empresa'])
  },
  methods: {
    ...mapActions(['ChangeTheme', 'UpdatePrefComp', '_UpdatePreference', '_UpdateMapsNets']),
    update () {
      this.updating = true
      this._UpdateMapsNets({
        maps: this.Empresa.maps,
        instagram: this.Empresa.instagram,
        facebook: this.Empresa.facebook,
        whatsapp: this.Empresa.whatsapp.replace('(', '').replace(')', '').replace(' ', '').replace('-', '')
      })
      .then(() => this._UpdatePreference())
      this.updating = false
    }
  }
}
</script>

<style scoped>
.EnbPreference {
  width: 96%;
  height: 92%;
  padding: 2%;
}

.cont-view {
  width: 96%;
  height: 85%;
  overflow: auto;
}

.cont-btn {
  text-align: left;
  padding-left: 1%;
}

button {
  border: 0;
  background-color: #000000;
  color: #FFFFFF;
  border-radius: 5px;
  padding: 1%;
  font-size: 16px;
  cursor: pointer
}

button:disabled {
  opacity: 0.60;
}

@media (max-width: 500px) {
  .EnbPreference {
    height: 75%;
  }
}
</style>
